import {useEffect} from "react";
const loginUrl=process.env.REACT_APP_LOGIN_URL
const Logout = props => {
    useEffect(()=>{
        sessionStorage.removeItem('token')
        sessionStorage.clear()
        window.location.href=`${loginUrl}`
    },[])
    return (
        <>

        </>
    )
}

export default Logout;
